import { FieldParam, ParamsConfDto } from '@/types/ParametersConfiguration';
import { SET_PARAMS_CONFIG, SET_PARAM_CONFIGURATION } from '../types';

export const setParamsConfig = (data: ParamsConfDto) => ({
  type: SET_PARAMS_CONFIG,
  payload: data,
});

export const setParamConfiguration = (key: string, value: FieldParam) => ({
  type: SET_PARAM_CONFIGURATION,
  payload: {
    key,
    value,
  },
});
